import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const MENTOR_IMAGE = 'https://cdn.magicpatterns.com/uploads/4zCA77ccagR9m3aBdgwRMG/Estratega_Susana_Sanchez.jpg';
export function MentorSection() {
  return <section aria-labelledby="mentor-heading" className="relative z-10 w-full border-t border-white/10 bg-[#0B0B0B] px-5 py-16 sm:px-8 md:py-24" data-id="element-214" data-mp="1kesattc07ma2">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-215" data-mp="2d3h3d3yzuja7">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative max-w-md mx-auto w-full" data-id="element-216" data-mp="283unsnvp0qy8">
          <div className="absolute inset-0 rounded-3xl bg-gold-metallic/15 -rotate-3 scale-105" aria-hidden="true" data-id="element-217" data-mp="2r2ql482ullga" />
          <img src={MENTOR_IMAGE} alt="Susana Sánchez G" className="relative z-10 w-full rounded-3xl shadow-2xl object-cover aspect-[4/5] ring-4 ring-gold-metallic/30" data-id="element-218" data-mp="t8889p9pxsio" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-219" data-mp="oem8gxonlj4a">
          <h2 id="mentor-heading" className="font-sans text-2xl md:text-3xl font-bold uppercase mb-6 text-white" data-id="element-220" data-mp="j1e12harp38">
            Conoce a Susana Sánchez&nbsp;G
          </h2>

          <figure className="mb-8 relative rounded-xl bg-white/[0.04] border border-white/10 p-6" data-id="element-221" data-mp="1ut51xp0faqui">
            <QuoteIcon className="absolute top-3 left-3 w-9 h-9 text-gold-metallic/25" aria-hidden="true" data-id="element-222" data-mp="1zs81wv1jq6vm" />
            <blockquote className="relative z-10 pl-4 border-l-4 border-gold-metallic text-xl md:text-2xl font-heading italic text-gold-metallic" data-id="element-223" data-mp="1tdsqthjwd0g5">
              "Mi objetivo es que tu capital sea el que trabaje horas extra, no
              tú."
            </blockquote>
          </figure>

          <div className="space-y-4 text-base md:text-lg text-white/70 leading-relaxed" data-id="element-224" data-mp="2h46eywzd2f5g">
            <p data-id="element-225" data-mp="2c40fwvqrhqdc">
              <strong className="text-white" data-id="element-226" data-mp="2c4aakwmr4lpd">Susana Sánchez G</strong> es
              especialista en Bienes Raíces e Inversiones de Flujo.
            </p>
            <p data-id="element-227" data-mp="27bh4o5fjr7bp">
              Se dedica a auditar y seleccionar vehículos financieros que
              ofrezcan el equilibrio perfecto entre Seguridad Patrimonial y
              Maximización de Dividendos.
            </p>
            <p data-id="element-228" data-mp="2v2w9c4usq0q4">
              Es la arquitecta detrás de cientos de estrategias de jubilación
              anticipada en Latinoamérica.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}